import { render, staticRenderFns } from "./UserDashboardSubscriptions.vue?vue&type=template&id=59e9bc8c&scoped=true&"
import script from "./UserDashboardSubscriptions.vue?vue&type=script&lang=js&"
export * from "./UserDashboardSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e9bc8c",
  null
  
)

export default component.exports